import script from "./MyTestimonialEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./MyTestimonialEditor.vue?vue&type=script&setup=true&lang=js"

import "./MyTestimonialEditor.vue?vue&type=style&index=0&id=7342b488&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7342b488"]])

export default __exports__